import { useRef, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { redeemReward, getRewardSections } from '../redux/data/dataActions';
import { setInvalidPhoneNumber, setPhoneNumber, setRedeemRewardLoading, setTermsAndConditions } from '../redux/data/dataSlice';
import LinkoutSVG from "./linkoutSvg";
import LoadingGif from "../assets/images/loader.gif";
import config from "../config/memberhubContents.json";
import "../assets/css/benefits.css";

function ModalCTA(props) {
    const dispatch = useDispatch();
    const redeemedReward = useSelector(state => state.data.redeemedReward);
    const redeemedRewardLoading = useSelector(state => state.data.redeemRewardLoading);
    const redeemedRewardError = useSelector(state => state.data.redeemedRewardError);
    const phoneNumber = useSelector(state => state.data.phoneNumber);
    const termsAndConditions = useSelector(state => state.data.termsAndConditions);
    const invalidPhoneNumber = useSelector(state => state.data.invalidPhoneNumber);
    const tabSelected = useSelector(state => state.data.tabSelected);
    const btnRef = useRef();
    const pathRef = useRef();

    let clickedGetCode = (event, reward) => {
        if (props.reward.reference_id === "sweepstakes") {
            if (props.reward.is_phone_number_required === 1 && props.reward.reward_terms && props.reward.max_select_quantity !== 0 && (!phoneNumber || !termsAndConditions || invalidPhoneNumber)) {
                //reward with both phone number and T&C
                if (!termsAndConditions) {
                    const terms = document.querySelector("#termsError");
                    if (terms) {
                        terms.innerHTML = config.termsAndConditionError;
                    }
                }

                if (!phoneNumber && !invalidPhoneNumber) {
                    const phone = document.querySelector("#phoneError");
                    if (phone) {
                        phone.innerHTML = config.phoneNumberRequiredError;
                    }

                    const input = document.querySelector('.PhoneInputInput');
                    if (input) {
                        input.style.borderBottom = "1px solid #ff3b30";
                    }
                }
                event.prevenDefault();
            } else if (props.reward.reward_terms && props.reward.max_select_quantity !== 0 && !termsAndConditions) {
                //reward with only T&C 
                const terms = document.querySelector("#termsError");
                if (terms) {
                    terms.innerHTML = config.termsAndConditionError;
                }
                event.prevenDefault();
            } else if (props.reward.is_phone_number_required === 1 && props.reward.max_select_quantity !== 0 && !phoneNumber) {
                //reward with only phone number
                if (!invalidPhoneNumber) {
                    const phone = document.querySelector("#phoneError");
                    if (phone) {
                        phone.innerHTML = config.phoneNumberRequiredError;
                    }

                    const input = document.querySelector('.PhoneInputInput');
                    if (input) {
                        input.style.borderBottom = "1px solid #ff3b30";
                    }
                }
                event.prevenDefault();
            }
        }

        if (!reward.extra_data["amex"]) {
            dispatch(redeemReward(reward, phoneNumber));
        }

        props.setGetCodeClicked(true);

        dispatch(setPhoneNumber(""));
        dispatch(setTermsAndConditions(false));
        dispatch(setInvalidPhoneNumber(false));
        props.executeScrolltoTop();

        if (reward.extra_data["amex"]) {
            window.open(reward.extra_data["amex_url"], "_self");
        }
    };

    const codeAccessed = data => data.reference_id === "code_code" && data.redeemed && data.redeemed.codes;
    const isSoldOut = data => data.reference_id === "code_code" && !data.redeemed && data.extra_data && data.extra_data.sold_out === "1" && data.max_select_quantity === 0;

    useEffect(() => {
        console.log("ModalCTA: useEffect[]");

        const queryParams = new URLSearchParams(window.location.search);
        const queryStatus = queryParams.get("status");
        if (queryStatus && queryStatus !== "200") {
            props.setGetCodeClicked(true);
            dispatch(setRedeemRewardLoading(false));
        }
        console.log("ModalCTA: status:", queryStatus);
    }, [props, dispatch]);

    useEffect(() => {
        //show modal page 1 CTA if both phone number and T&C required and checked 
        if (props.reward.is_phone_number_required === 1 && props.reward.reward_terms && !invalidPhoneNumber && phoneNumber && termsAndConditions) {
            if (btnRef && btnRef.current) {
                btnRef.current.style.background = "#191C23";
                btnRef.current.style.color = "#FFFFFF";
            }
            if (pathRef && pathRef.current) {
                pathRef.current.style.fill = "#FFFFFF";
            }
        } else if (props.reward.is_phone_number_required !== 1 && props.reward.reward_terms && termsAndConditions) {
            //show modal page 1 CTA if only T&C required and checked 
            if (btnRef && btnRef.current) {
                btnRef.current.style.background = "#191C23";
                btnRef.current.style.color = "#FFFFFF";
            }
            if (pathRef && pathRef.current) {
                pathRef.current.style.fill = "#FFFFFF";
            }
        } else if (!props.reward.reward_terms && props.reward.is_phone_number_required === 1 && !invalidPhoneNumber && phoneNumber) {
            //show modal page 1 CTA if only phone number required and checked 
            if (btnRef && btnRef.current) {
                btnRef.current.style.background = "#191C23";
                btnRef.current.style.color = "#FFFFFF";
            }
            if (pathRef && pathRef.current) {
                pathRef.current.style.fill = "#FFFFFF";
            }
        } else if (props.reward.is_phone_number_required !== 1 && !props.reward.reward_terms) {
            //show modal page 1 CTA if both phone number and T&C is not required
            if (btnRef && btnRef.current) {
                btnRef.current.style.background = "#191C23";
                btnRef.current.style.color = "#FFFFFF";
            }
            if (pathRef && pathRef.current) {
                pathRef.current.style.fill = "#FFFFFF";
            }
        } else {
            // by default disable the modal page 1 CTA for sweepstakes
            if (props.reward.reference_id === "sweepstakes" && props.reward.max_select_quantity !== 0) {
                if (btnRef && btnRef.current) {
                    btnRef.current.style.background = "#BBBDBE";
                    btnRef.current.style.color = "#4E5356";
                }
                if (pathRef && pathRef.current) {
                    pathRef.current.style.fill = "#4E5356";
                }
            }
        }
    }, [phoneNumber, termsAndConditions, invalidPhoneNumber, props.reward]);

    return (
        <>
            {/* standard-info CTA condition  and standard - code with no url CTA condition*/}
            {(props.reward.reference_id === "standard" && !props.reward.extra_data["reward_url"]) &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    to={{ pathname: `/${tabSelected}`, search: window.location.search }}
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="benefits"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {config.closeRewardCTA}
                </Link>
            }
            {/* standard - url and standard - code CTA condition */}
            {(props.reward.reference_id === "standard" && props.reward.extra_data["reward_url"]) ?
                <>
                    <Link
                        ref={btnRef}
                        className="modal-button-cta"
                        data-track="click"
                        data-id="nba:membership-hub:outbound:cta"
                        data-content={props.reward.title}
                        data-type="cta"
                        target="_blank"
                        rel="noreferrer noopener"
                        to={ props.reward.extra_data.reward_url }
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getRewardSections("benefits"));
                        }}>
                        {props.reward.extra_data["reward_cta"] ?? config.standardRewardCodeURLCTA}&nbsp;<LinkoutSVG />
                    </Link>
                    {props.reward.extra_data["reward_url1"] && props.reward.extra_data["reward_cta1"] &&
                        <Link
                            style={{backgroundColor: "#191c23", color : "#FFF"}}
                            className="modal-button-cta"
                            data-track="click"
                            data-id="nba:membership-hub:outbound:cta"
                            data-content={props.reward.title}
                            data-type="cta"
                            target="_blank"
                            rel="noreferrer noopener"
                            to={ props.reward.extra_data.reward_url1}
                            onClick={() => {
                                props.setShowModal(false);
                                dispatch(getRewardSections("benefits"));
                            }}>
                            {props.reward.extra_data["reward_cta1"]}&nbsp;<LinkoutSVG />
                        </Link>
                    }
                </>: null
            }
            {/* code_code or sweepstakes or code_url Page 1 CTA condition when redemption API returns error */}
            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") && props.getCodeClicked && redeemedRewardError && redeemedRewardError.status === "error" && !redeemedRewardLoading &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    to={{ pathname: `/${tabSelected}`, search: window.location.search }}
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="benefits"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {props.reward.reference_id === "sweepstakes" ? config.sweepstakesRedeemCTA : config.closeRewardCTA}
                </Link>
            }
            {/* code_code or sweepstakes or code_url Page 1 CTA Loading condition */}
            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") &&
                props.getCodeClicked && props.reward.max_select_quantity !== 0 && redeemedRewardLoading &&
                    <div className="modal-button-cta">
                        <img className="modal-button-loading" src={LoadingGif} alt="Loading" />
                    </div>
            }
            {/* code_code or sweepstakes or code_url Page 1 CTA condition */}
            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes" || props.reward.reference_id === "code_url") &&
                !props.getCodeClicked && props.reward.max_select_quantity !== 0 && !isSoldOut(props.reward) && !codeAccessed(props.reward) &&
                    <div ref={btnRef} className="modal-button-cta" onClick={(e) => clickedGetCode(e, props.reward)}>
                        {props.reward.extra_data["reward_cta"] ?? props.reward.reference_id === "sweepstakes" ? config.sweepstakeCTA : config.codeRewardCTA}&nbsp;
                        <svg
                            width={17}
                            height={16}
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            <g clipPath="url(#clip0_1_2509)">
                                <path
                                    ref={pathRef}
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.281 8.66667L8.4191 13.5286L9.36191 14.4714L15.8333 8L9.36191 1.52859L8.4191 2.4714L13.281 7.33333H0.890505V8.66667H13.281Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clippath id="clip0_1_2509">
                                    <rect x="0.5" width={16} height={16} rx={8} fill="white" />
                                </clippath>
                            </defs>
                        </svg>
                    </div>
            }
            {/* Sold Out CTA */}
            { props.reward.reference_id === "code_code" && !props.getCodeClicked && isSoldOut(props.reward) && !codeAccessed(props.reward) &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    to={{ pathname: `/${tabSelected}`, search: window.location.search }}
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="benefits"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {config.closeRewardCTA}
                </Link>
            }
            {/* Redeemed CTA */}
            { props.reward.reference_id === "code_code" && !props.getCodeClicked && codeAccessed(props.reward) &&
                <>
                { props.reward.extra_data["reward_url"] &&
                    <Link
                        ref={btnRef}
                        className="modal-button-cta"
                        to={ props.reward.extra_data["reward_url"] }
                        target="_blank"
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="benefits"
                        data-type="dismiss"
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getRewardSections("benefits"));
                        }}>
                        {props.reward.extra_data["reward_cta"] ?? config.codeRewardRedeemCTA}&nbsp;<LinkoutSVG />
                    </Link>
                }
                { !props.reward.extra_data["reward_url"] &&
                    <Link
                        ref={btnRef}
                        className="modal-button-cta"
                        to={{ pathname: `/${tabSelected}`, search: window.location.search }}
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="benefits"
                        data-type="dismiss"
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getRewardSections("benefits"));
                        }}>
                        {config.closeRewardCTA}
                    </Link>
                }
                </>
            }
            {/* code_code or sweepstakes Page 2 CTA condition when no URL to link to CTA (no reward_url in extra_data) */}
            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes") && !props.reward.extra_data["reward_url"] && props.getCodeClicked && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    to={{ pathname: `/${tabSelected}`, search: window.location.search }}
                    data-track="click"
                    data-id="nba:membership-hub:dismiss"
                    data-section="benefits"
                    data-type="dismiss"
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {props.reward.reference_id === "code_code" && config.closeRewardCTA}
                    {props.reward.reference_id === "sweepstakes" && config.sweepstakesRedeemCTA}
                </Link>
            }
            {/* code_code or sweepstakes Page 2 CTA when URL exists(extra_data.reward_url is present) */}
            {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes") && props.reward.extra_data["reward_url"] && props.getCodeClicked && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    data-track="click"
                    data-id="nba:membership-hub:outbound:cta"
                    data-content={props.reward.title}
                    data-type="cta"
                    target="_blank"
                    rel="noreferrer noopener"
                    to={ props.reward.extra_data["reward_url"] }
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {props.reward.extra_data["reward_cta"] ?? config.codeRewardRedeemCTA}&nbsp;<LinkoutSVG />
                </Link>
            }
            {/* code_url Page 2 CTA where url is picked from user redemption API response */}
            {(props.reward.reference_id === "code_url") && props.getCodeClicked && redeemedReward && Object.keys(redeemedReward).length > 0 && !redeemedRewardLoading && (!redeemedRewardError || Object.keys(redeemedRewardError).length === 0) && redeemedReward.data && redeemedReward.data.codes && redeemedReward.data.codes.length > 0 && redeemedReward.data.codes[0] &&
                <Link
                    ref={btnRef}
                    className="modal-button-cta"
                    data-track="click"
                    data-id="nba:membership-hub:outbound:cta"
                    data-content={props.reward.title}
                    data-type="cta"
                    target="_blank"
                    rel="noreferrer noopener"
                    to={ redeemedReward.data.codes[0] }
                    onClick={() => {
                        props.setShowModal(false);
                        dispatch(getRewardSections("benefits"));
                    }}>
                    {props.reward.extra_data["reward_cta"] ?? config.codeRewardRedeemCTA}&nbsp;<LinkoutSVG />
                </Link>
            }
            {/* warning state CTAs */}
            {!props.getCodeClicked && props.reward.max_select_quantity === 0 && !isSoldOut(props.reward) && !codeAccessed(props.reward) &&
                <>
                    {/* Warning state - code_code or sweepstakes reward with no URL(no reward_url in extra_data) */}
                    {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes") && !props.reward.extra_data["reward_url"] &&
                        <Link
                            ref={btnRef}
                            className="modal-button-cta"
                            to={{ pathname: "/benefits", search: window.location.search }}
                            data-track="click"
                            data-id="nba:membership-hub:dismiss"
                            data-section="benefits"
                            data-type="dismiss"
                            onClick={() => {
                                props.setShowModal(false);
                                dispatch(getRewardSections("benefits"));
                            }}>
                            {props.reward.reference_id === "code_code" && config.closeRewardCTA}
                            {props.reward.reference_id === "sweepstakes" && config.sweepstakesRedeemCTA}
                        </Link>
                    }
                    {/* Warning state - code_code or sweepstakes with URL(reward_url in extra_data) */}
                    {(props.reward.reference_id === "code_code" || props.reward.reference_id === "sweepstakes") && props.reward.extra_data["reward_url"] &&
                        <Link
                            ref={btnRef}
                            className="modal-button-cta"
                            data-track="click"
                            data-id="nba:membership-hub:outbound:cta"
                            data-content={props.reward.title}
                            data-type="cta"
                            target="_blank"
                            rel="noreferrer noopener"
                            to={ props.reward.extra_data["reward_url"] }
                            onClick={() => {
                                props.setShowModal(false);
                                dispatch(getRewardSections("benefits"));
                            }}>
                            {props.reward.extra_data["reward_cta"] ?? config.codeRewardRedeemCTA}&nbsp;<LinkoutSVG />
                        </Link>
                    }
                    {/* Warning state - code_url with URL(url in redeemed section of user reward API response) */}
                    {props.reward.reference_id === "code_url" && props.reward.redeemed.codes[0].code &&
                        <Link
                            ref={btnRef}
                            className="modal-button-cta"
                            data-track="click"
                            data-id="nba:membership-hub:outbound:cta"
                            data-content={props.reward.title}
                            data-type="cta"
                            target="_blank"
                            rel="noreferrer noopener"
                            to={ props.reward.redeemed.codes[0].code }
                            onClick={() => {
                                props.setShowModal(false);
                                dispatch(getRewardSections("benefits"));
                            }}>
                            {props.reward.extra_data["reward_cta"] ?? config.codeRewardRedeemCTA}&nbsp;<LinkoutSVG />
                        </Link>
                    }
                </>
            }
        </>
    );
}

export default ModalCTA;
